import { ADD_PARTY_DISCOUNT } from "../../types/PartyDiscountType";
import axios from "axios";
import { toast } from "react-toastify";

const addPartyDiscountAction = (data) => {
	return {
		type: ADD_PARTY_DISCOUNT,
		payload: data,
	};
};

export const addPartyDiscount = (values) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `product-currency/`,
				data: {
					...values,
				},
			});
			//dispatching data
			dispatch(addPartyDiscountAction(data));
			toast.success("product Currency Added");
			return {
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding currency try again");
			console.log(error.message);
		}
	};
};
